import dayjs from 'dayjs';
import { headers } from '../const/headers'
import { snackbar } from '@/core/controller/snackbar_controller';

class EquipmentStatusController {
    context = null
    headers = headers
    loading = false
    mapLogs = []
    mapStartDate = null
    mapEndDate = null
    search = ""
    searchEquipmentStatusLog = ""
    mapDialog = false
    logDialog = false
    selectedEquipment = null
    selectedEquipmentStatus = null
    selectedLog = null
    isFromLogClick = false
    logTypeSelected = 0
    logTypeList = [
      { text: "Todos", value: 0 },
      { text: "Informação", value: 1 },
      { text: "Aviso", value: 2 },
      { text: "Erro", value: 3 },
    ]

    equipmentStatusLogPagination = {
        total: 0,
        items: []
    }
    
    equipmentStatusLogOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["logDate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: [true],
        equipmentStatusID: 0,
    }

    equipmentStatusPagination = {
        total: 0,
        items: []
    }

    options = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["updatedDate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: [true],
    }

    constructor(
        context,
        fetchEquipmentStatusUseCaseImpl,
        fetchEquipmentStatusLogUseCaseImpl
    ) {
        this.context = context;
        this.fetchEquipmentStatusUseCaseImpl = fetchEquipmentStatusUseCaseImpl;
        this.fetchEquipmentStatusLogUseCaseImpl = fetchEquipmentStatusLogUseCaseImpl;
    }

    async paginate() {
      this.loading = true
      try {
        this.equipmentStatusPagination = await this.fetchEquipmentStatusUseCaseImpl(this.options, this.search);
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 });
      } finally {
        this.loading = false
      }
    }

    async equipmentStatusLogPaginate() {
      this.loadingLogs = true
      try {
        this.equipmentStatusLogPagination = await this.fetchEquipmentStatusLogUseCaseImpl(this.equipmentStatusLogOptions, this.searchEquipmentStatusLog, this.logTypeSelected)
      } catch (error) {
        console.log(error);
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 });
      } finally {
        this.loadingLogs = false;
      }
    }

    watchOptions() {
      this.paginate()
    }
    
    watchSearch() {
      this.paginate()
    }
    
    watchEquipmentStatusLogOptions() {
      this.equipmentStatusLogPaginate()
    }
    
    watchSearchEquipmentStatusLog() {
      this.equipmentStatusLogPaginate() 
    }

    watchMapDialog(isOpen) {
      if (isOpen) {
        this.context.$nextTick(() => {
          setTimeout(() => {
            const leafletMapComponent = this.context.$refs.leafletMap;
            if (leafletMapComponent && typeof leafletMapComponent.initialize === 'function') {
                leafletMapComponent.initialize();
            }
          }, 200);
        });
      }
    }

    watchMapStartDate() {
      if (this.selectedEquipment) {
          this.loadLogsForMap(this.selectedEquipment.id);
      }
    }

    watchMapEndDate() {
      if (this.selectedEquipment) {
          this.loadLogsForMap(this.selectedEquipment.id);
      }
    }

    async watchSelectedEquipment(equipmentSelected, currentEquipment) {
      if (!this.isFromLogClick && equipmentSelected !== currentEquipment) {
          this.selectedLog = null;
      }
      if (equipmentSelected) {
          this.previousEquipmentId = equipmentSelected.equipmentID;
          await this.loadLogsForMap(equipmentSelected.id);
      }
    }

    openLogDialog(item) {
      
      this.selectedEquipmentStatus = item.equipmentName
      this.equipmentStatusLogOptions.equipmentStatusID = item.id
    
      this.logTypeSelected = 0
      this.loadingLogs = true;
      this.logDialog = true;
      this.equipmentStatusLogPaginate();
    }

    closeLogDialog() {
      this.equipmentStatusLogOptions.page = 1
      this.loadingLogs = false
      this.logDialog = false
    }

    changeLogType() {
      this.equipmentStatusLogPaginate()
    }

    openMapDialog() {
      this.mapStartDate = dayjs().startOf('month').format("YYYY-MM-DD")
      this.mapEndDate = dayjs().endOf('month').format("YYYY-MM-DD")
      this.mapDialog = true;
      this.selectedEquipment = null;
      this.selectedLog = null;
      this.mapLogs = [];
    }

    closeMapDialog() {
      this.mapDialog = false;
      this.selectedEquipment = null;
      this.selectedLog = null;
      this.mapLogs = []
    }

    viewOnMap(item) {
      this.mapStartDate = dayjs().startOf('month').format("YYYY-MM-DD")
      this.mapEndDate = dayjs().endOf('month').format("YYYY-MM-DD")
      this.selectedEquipment = item;
      this.selectedLog = null;
      this.previousEquipmentId = item.equipmentID;
      this.mapDialog = true;
    }

    async loadLogsForMap(equipmentStatusID) {
      try {
        const baseOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["logDate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: [false],
        equipmentStatusID,
        startDate: this.mapStartDate || null,
        endDate: this.mapEndDate || null,
        };

        const firstRes = await this.fetchEquipmentStatusLogUseCaseImpl(baseOptions, "", 0);
        const total = firstRes && typeof firstRes.total === 'number' ? firstRes.total : (firstRes.items ? firstRes.items.length : 0);

        const fullOptions = {
            ...baseOptions,
            itemsPerPage: total > 0 ? total : baseOptions.itemsPerPage,
        };
        const fullRes = await this.fetchEquipmentStatusLogUseCaseImpl(fullOptions, "", 0);
        this.mapLogs = (fullRes && fullRes.items) ? fullRes.items : [];
      } catch (e) {
        console.log(e);
        this.mapLogs = [];
      }
    }

     async viewLogOnMap(log) {
      const logDay = dayjs(log.logDate).format('YYYY-MM-DD');
      this.mapStartDate = logDay;
      this.mapEndDate = logDay;
      const equipment = this.equipmentStatusPagination.items.find(
          (i) => i.id === this.equipmentStatusLogOptions.equipmentStatusID
      );
      this.isFromLogClick = true;
      this.selectedEquipment = equipment || null;
      this.selectedLog = log;
      if (equipment) {
          await this.loadLogsForMap(equipment.id);
      }
      this.mapDialog = true;
      setTimeout(() => {
          this.isFromLogClick = false;
      }, 500);
    }  
  
    getEquipmentsWithLocation() {
      return this.equipmentStatusPagination.items.filter(
        item => item.latitude && item.longitude
      );
    }

    getMapMarkers() {
      if (this.selectedEquipment) {
        const markers = [];
        markers.push({
          ...this.selectedEquipment,
          isCurrentStatus: true
        });

        const logsArray = this.mapLogs || [];
        logsArray.forEach(log => {
          if (log.latitude && log.longitude) {
            const isSelected = this.selectedLog && log.id === this.selectedLog.id;
            markers.push({
              ...log,
              equipmentName: this.selectedEquipment.equipmentName,
              isLog: true,
              isSelectedLog: isSelected
            });
          }
        });

        if (
          this.selectedLog &&
          this.selectedLog.latitude && this.selectedLog.longitude &&
          !logsArray.some(l => l.id === this.selectedLog.id)
        ) {
          markers.push({
            ...this.selectedLog,
            equipmentName: this.selectedEquipment.equipmentName,
            isLog: true,
            isSelectedLog: true
          });
        }

        return markers;
      }
      
      return this.equipmentStatusPagination.items.filter(
        item => item.latitude && item.longitude
      );
    }
    
     getMapCenter() {
      if (this.selectedLog && 
          this.selectedLog.latitude && 
          this.selectedLog.longitude) {
        return [
          this.selectedLog.latitude,
          this.selectedLog.longitude
        ];
      }
      
      if (this.selectedEquipment && 
          this.selectedEquipment.latitude && 
          this.selectedEquipment.longitude) {
        return [
          this.selectedEquipment.latitude,
          this.selectedEquipment.longitude
        ];
      }
      
      return [-15.7801, -47.9292];
    }
    
    getLogIcon(logTypeID) {
      switch (logTypeID) {
        case 1: return "mdi-information-outline";
        case 2: return "mdi-alert-outline";
        case 3: return "mdi-alert-circle-outline";
        default: return "mdi-text-box-outline";
      }
    }
}

export default EquipmentStatusController